require("typeface-inter");
require("./src/animation.css");
